import _ from "lodash";

import {
  Component,
} from "react";
import {
  Button,
  Col,
  Modal,
  Row,
} from "react-bootstrap";

import store from "CommonState/store";
import DashboardWidgetAngaben, {
  updateStats,
} from "Components/db-widget-angaben";
import DashboardWidgetMassnahmen from "Components/db-widget-massnahmen";
import DashboardWidgetAnträge from "Components/db-widget-antraege";
import DashboardWidgetAenderungen from "Components/db-widget-aenderungen";
import DashboardWidgetAntragFilter from "Components/db-widget-antragfilter";
import DashbordWidgetWorkflow from "Components/db-widget-workflow";

import AntragListPage from "App/antrag-list-page";

import {
  ALLEMODI,
  ANTRAGSTATUS,
  ANTRAGSTELLERMODUS,
  ANTRAGSTYPEN,
  ASTMODUSEMPTY,
  ASTMODUSKEY,
  ROLLEN,
  userDashboard,
} from "App/constants";
import apifetch from "CommonCore/apifetch";
import {
  saveSetting,
} from "Apis/nutzer-api";
import {
  Panel,
} from "CommonComponents/bricks";
import {
  ControlGenerators,
} from "CommonComponents/detail-view";
import {
  getModus,
} from "App/antragsteller-modus";

@store("user", "k_antragstatusLookup", "k_nutzerLookup", "rolleLookup", "flag_antragstellermodus", "k_antragstypLookup")
export default class HomePage extends Component {
  constructor() {
    super();
    this.state = { showAstmodusDialog: false };
  }

  componentDidUpdate = async prevProps => {
    const { flag_antragstellermodus } = this.props;
    if (prevProps.flag_antragstellermodus !== flag_antragstellermodus) {
      const modus = await getModus(this.props, true);
      this.setState({ showAstmodusDialog: modus == ASTMODUSEMPTY });
    }
  };

  componentDidMount = async() => {
    const { user } = this.props;
    if (user && userDashboard(user)) {
      // Dashboarddaten laden
      const data = await apifetch(`/api/shkantrag/dashboard`);
      const dashboarddata = {
        bearbeitung: { label: "Anträge zur Bearbeitung annehmen", wert: data.bearbeitung },
        meine: { label: "Meine Anträge in Bearbeitung", wert: data.meine },
        sva: { label: "Daten an SVA weiterleiten", wert: data.sva },
        weiter: { label: "Weitergeleitete Anträge ansehen", wert: data.weiter },
        vortraege: { label: "Alle Anträge in Bearbeitung", wert: data.vortraege },
        sachgebietsleitung: { label: "Anträge bei Sachgebietsleitung", wert: data.sachgebietsleitung },
        inerstellung: { label: user.ro_id == ROLLEN.ROLLE_DEZ1_3 ? "Verträge in Erstellung" : [ROLLEN.ROLLE_SACHBEARBEITER_TARIF, ROLLEN.ROLLE_SACHGEBIETSLEITUNG].includes(user.ro_id) ? "Arbeitsverträge in Erstellung" : "Dienstverträge in Erstellung", wert: data.inerstellung },
        werkvertrag: { label: "Werkverträge", wert: data.werkvertrag },
      };
      this.setState({ dashboarddata });
    }
    const modus = await getModus(this.props, true);
    this.setState({ showAstmodusDialog: modus == ASTMODUSEMPTY });
  };

  render() {
    const { user, flag_antragstellermodus } = this.props;
    const { showAstmodusDialog } = this.state;

    if (!(userDashboard(user) || user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER)) {
      // Diese Rollen haben kein echtes Dashboard
      return <AntragListPage />;
    }
      // Zweig für Rollen mit Dashboards
    return <div>
      {user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER &&
          <span>
            <div className='row'>
              <div className='col-md-12'>
                <AntragstellerModusWidget asModal={showAstmodusDialog} />
              </div>
            </div>
            {flag_antragstellermodus && flag_antragstellermodus != ASTMODUSKEY.WerkGewerbe &&
              <div className='row'>
                <div className='col-md-6'>
                  <DashbordWidgetWorkflow AntragstellerModus={flag_antragstellermodus} />
                  <DashboardWidgetAngaben AntragstellerModus={flag_antragstellermodus} />
                </div>
                <div className='col-md-6'>
                  <DashboardWidgetMassnahmen AntragstellerModus={flag_antragstellermodus} />
                  <DashboardWidgetAnträge AntragstellerModus={flag_antragstellermodus} />
                  <DashboardWidgetAenderungen />
                </div>

              </div>}
          </span>
      }
      {userDashboard(user) &&
          <span>
            <div className='row'>
              {this.getDashboardTiles().map(tile => (
                <div className='col-md-6' key={tile.key}>
                  <DashboardWidgetAntragFilter setFilter={tile.setFilter} data={tile.data} />
                </div>
              ))}
            </div>

          </span>

      }
      {user.ro_id === ROLLEN.ROLLE_ADMIN &&
          <h4>Administration</h4>
      }

    </div>;
  }
  setFilterMeine = () => {
    if (!this.props.k_nutzerLookup) {
      return false;
    }
    this.props.clearUiListFilters("antragaktivList");
    const n = this.props.k_nutzerLookup[this.props.user.n_id];
    this.props.setUiListFilterCriteria("antragaktivList", "a_sb_nid", [`${ n.n_vorname } ${ n.n_name }`]);
  };
  setFilterWeiter = () => {
    const { k_nutzerLookup, rolleLookup } = this.props;
    if (!k_nutzerLookup || !rolleLookup) {
      return false;
    }

    this.props.clearUiListFilters("antragaktivList");
    const n = k_nutzerLookup[this.props.user.n_id];
    this.props.setUiListFilterCriteria("antragaktivList", "a_sb_nid", [`${ n.n_vorname } ${ n.n_name }`]);
    this.props.setUiListFilterCriteria("antragaktivList", "zust_rolle", _.map(_.omit(rolleLookup, this.props.user.ro_id), r => r.ro_kbez));
  };
  setFilterWerkvertrag = () => {
    const { k_antragstypLookup } = this.props;
    if (!k_antragstypLookup) {
      return false;
    }
    const crit = [k_antragstypLookup[ANTRAGSTYPEN.WERKVERTRAG].kat_kbez, k_antragstypLookup[ANTRAGSTYPEN.HONORARVERTRAG].kat_kbez];

    this.props.clearUiListFilters("antragaktivList");
    this.props.setUiListFilterCriteria("antragaktivList", "a_katid", crit);
  };
  setFilterZurBearbeitung = () => {
    const { k_antragstatusLookup } = this.props;
    if (!k_antragstatusLookup) {
      return false;
    }

    this.props.clearUiListFilters("antragaktivList");
    this.props.setUiListFilterCriteria("antragaktivList", "a_sb_nid", [null]);
    this.props.setUiListFilterCriteria("antragaktivList", "meineer", [true]);
    this.props.setUiListFilterCriteria("antragaktivList", "a_asid", _.map(_.filter(k_antragstatusLookup, f => f.as_id != ANTRAGSTATUS.STATUS_NEU && f.as_id != ANTRAGSTATUS.STATUS_ABGEBROCHEN), item => item.as_bez));
  };
  setFilterZurBearbeitungVortrag = () => {
    const { k_antragstatusLookup } = this.props;
    if (!k_antragstatusLookup) {
      return false;
    }

    const status = _.get(k_antragstatusLookup, [ANTRAGSTATUS.STATUS_VORTRAG_PRUEFUNG, "as_bez"]);
    if (!status) {
      return false;
    }

    this.props.clearUiListFilters("antragaktivList");
    this.props.setUiListFilterCriteria("antragaktivList", "a_sb_nid", [null]);
    this.props.setUiListFilterCriteria("antragaktivList", "a_asid", [status]);
  };
  setFilterAnSVA = () => {
    const { k_antragstatusLookup } = this.props;
    if (!k_antragstatusLookup || !this.props.k_nutzerLookup) {
      return false;
    }
    const n = this.props.k_nutzerLookup[this.props.user.n_id];
    this.props.clearUiListFilters("antragaktivList");
    this.props.setUiListFilterCriteria("antragaktivList", "a_asid", _.map(_.filter(k_antragstatusLookup, f => [ANTRAGSTATUS.STATUS_DATEN_AN_SVA, ANTRAGSTATUS.STATUS_TARIFDATEN_AN_SVA].includes(f.as_id)), item => item.as_bez));
    this.props.setUiListFilterCriteria("antragaktivList", "a_sb_nid", [`${ n.n_vorname } ${ n.n_name }`]);
  };
  setFilterSachgebietsleitung = () => {
    const { k_antragstatusLookup } = this.props;
    if (!k_antragstatusLookup) {
      return false;
    }

    const status = _.get(k_antragstatusLookup, [ANTRAGSTATUS.STATUS_SACHGEBIETSLEITUNG, "as_bez"]);
    if (!status) {
      return false;
    }

    this.props.clearUiListFilters("antragaktivList");
    this.props.setUiListFilterCriteria("antragaktivList", "a_asid", [status]);
  };
  setFilterVortraege = () => {
    const { k_antragstatusLookup, k_nutzerLookup, rolleLookup, user } = this.props;
    if (!k_antragstatusLookup || !k_nutzerLookup || !rolleLookup) {
      return false;
    }

    const rolle = rolleLookup[user.ro_id];
    if (!rolle) {
      return false;
    }

    this.props.clearUiListFilters("antragaktivList");
    this.props.setUiListFilterCriteria("antragaktivList", "zust_rolle", [rolle.ro_kbez]);
    this.props.setUiListFilterCriteria(
      "antragaktivList",
      "a_asid",
      _.map(_.filter(k_antragstatusLookup, f => f.as_id != ANTRAGSTATUS.STATUS_VORTRAG_ABGESCHLOSSEN), item => item.as_bez),
    );
    // nur Anträge, denen bereits ein Sachbearbeiter zugeordnet ist
    this.props.setUiListFilterCriteria(
      "antragaktivList",
      "a_sb_nid",
      _.map(k_nutzerLookup, n => `${ n.n_vorname } ${ n.n_name }`),
    );
  };
  setFilterInErstellung = () => {
    const { k_antragstatusLookup, k_nutzerLookup, user } = this.props;
    if (!k_antragstatusLookup || !k_nutzerLookup) {
      return false;
    }

    this.props.clearUiListFilters("antragaktivList");
    const n = k_nutzerLookup[user.n_id];
    this.props.setUiListFilterCriteria("antragaktivList", "a_sb_nid", [`${ n.n_vorname } ${ n.n_name }`]);
    this.props.setUiListFilterCriteria(
      "antragaktivList",
      "a_asid",
      _.map(ALLEMODI.statusErstellen, status => _.get(k_antragstatusLookup, [status, "as_bez"], "")),
    );
  };
  getDashboardTiles = () => {
    const { user } = this.props;
    const { dashboarddata } = this.state;
    const tiles = [
      { key: "meine", setFilter: this.setFilterMeine, data: dashboarddata && dashboarddata.meine },
      ...(user.ro_id !== ROLLEN.ROLLE_DEZ1_3 ? [{ key: "weiter", setFilter: this.setFilterWeiter, data: dashboarddata && dashboarddata.weiter }] : []),
      {
        key: "bearbeitung",
        setFilter: user.ro_id === ROLLEN.ROLLE_DEZ1_3 ? this.setFilterZurBearbeitungVortrag : this.setFilterZurBearbeitung,
        data: dashboarddata && dashboarddata.bearbeitung,
      },
    ];

    if (user.ro_id !== ROLLEN.ROLLE_DEZ1_3) {
      tiles.push({ key: "sva", setFilter: this.setFilterAnSVA, data: dashboarddata && dashboarddata.sva });
    }
    if (user.ro_id === ROLLEN.ROLLE_SACHGEBIETSLEITUNG) {
      tiles.push({ key: "sachgebietsleitung", setFilter: this.setFilterSachgebietsleitung, data: dashboarddata && dashboarddata.sachgebietsleitung });
    }
    if (user.ro_id === ROLLEN.ROLLE_DEZ1_3) {
      tiles.push({ key: "vortraege", setFilter: this.setFilterVortraege, data: dashboarddata && dashboarddata.vortraege });
    }

    if (user.ro_id !== ROLLEN.ROLLE_DEZ1_3) {
      tiles.push({ key: "inerstellung", setFilter: this.setFilterInErstellung, data: dashboarddata && dashboarddata.inerstellung });
    }

    if (user.ro_id === ROLLEN.ROLLE_SACHBEARBEITER_SHK) {
      tiles.push({ key: "werkvertrag", setFilter: this.setFilterWerkvertrag, data: dashboarddata && dashboarddata.werkvertrag });
    }

    return tiles;
  };
}

@store("user", "flag_antragstellermodus")
class AntragstellerModusWidget extends Component {
  constructor() {
    super();
    this.state = {
      liste: _.map(ANTRAGSTELLERMODUS, obj => obj),
      astmodus: ASTMODUSEMPTY,
    };
  }

  render() {
    const { user, flag_antragstellermodus, asModal } = this.props;
    const { liste, astmodus } = this.state;
    if (user && user.ro_id != ROLLEN.ROLLE_ANTRAGSTELLER) {
      return null;
    }

    const current = _.find(liste, x => x.value == flag_antragstellermodus || x.value == astmodus);
    const content = <Row>
      <Col sm={6}>
        {ControlGenerators.select({
          entity: { flag_antragstellermodus: astmodus != ASTMODUSEMPTY ? astmodus : flag_antragstellermodus },
          leftCol: 0,
          rightCol: 12,
          schema: { field: "flag_antragstellermodus", searchable: false, required: true, default: () => -1, hideLabel: true, type: "select", choices: this.state.liste },
          onChange: this.setValue,
          rightColStyle: { float: "none" },
        })}</Col>
      {current && <Col sm={4}>{current.desc}</Col>}
    </Row>;

    if (asModal) {
      return <Modal show backdrop='static'>
        <Modal.Header>
          <h3>Wählen Sie Ihr Ziel</h3>
        </Modal.Header>
        <Modal.Body>
          {content}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' disabled={astmodus == ASTMODUSEMPTY} onClick={this.save}>
            Speichern
          </Button>
        </Modal.Footer>
      </Modal>;
    }
    return <Panel style={{ backgroundColor: "#f0f0f0" }}>
      {content}
    </Panel>;
  }
  setValue = async(schema, value) => {
    const { asModal } = this.props;
    this.setState({ astmodus: value });

    if (!asModal) {
      await this.save(null, value);
    }
  };

  save = async(dummy, value) => {
    const { astmodus } = this.state;
    this.props.setFlag("antragstellermodus", value || astmodus);
    await saveSetting("AntragstellerModus", { modus: value || astmodus });
    updateStats(this.props, value || astmodus);
  };
}
